import { gettext } from './text';

export const VISIBILITY_PUBLIC = 3;
export const VISIBILITY_PUBLIC_DISPLAY = gettext('Public - everyone can see your comment');

export const MEDIA_TYPES = {
    PHOTO: 'P',
    VIDEO: 'V',
    AUDIO: 'A',
    TEXT: 'T',
};



// WEBPACK FOOTER //
// ./src/utils/constants.js